import { render, staticRenderFns } from "./comp_hotImg.vue?vue&type=template&id=56e92384&scoped=true"
import script from "./comp_hotImg.vue?vue&type=script&lang=js"
export * from "./comp_hotImg.vue?vue&type=script&lang=js"
import style0 from "./comp_hotImg.vue?vue&type=style&index=0&id=56e92384&prod&lang=scss&scoped=true"
import style1 from "./comp_hotImg.vue?vue&type=style&index=1&id=56e92384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e92384",
  null
  
)

export default component.exports